import { MantineThemeOverride } from '@mantine/core';

const theme: MantineThemeOverride  = { 
    colorScheme: 'light', 
    fontFamily: 'Euclid Circular B',
    headings: { fontFamily: 'Euclid Circular B' },
    primaryColor: 'blue',
    black: '#050505'
}

export default theme;